import React, { useState } from 'react';
import Tooltip from '../../../../../components/Tooltip/Tooltip';

const style = {
  width: '18%',
  display: 'flex',
};

/**
 * @param {string} text
 * @param {string} hoverText
 * @returns {JSX.Element}
 * @constructor
 */
const UsageHoverLabel = ({ text, hoverText, className }) => {
  const [isHover, setIsHover] = useState(false);
  return (
    <div className={className} onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
      {text}
      <Tooltip text={hoverText} isHover={isHover} />
    </div>
  );
};

export default UsageHoverLabel;
